import { getSessionUUID } from '../components/lib/AuthToken';

// Training module admin API calls

const h = async (extra = {}) => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${await getSessionUUID()}`,
    ...extra,
});

export const getTrainingCategories = async () => {
    try {
        const r = await fetch('/training/categories', { headers: await h(), credentials: 'include' });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const createTrainingCategory = async (name) => {
    try {
        const r = await fetch('/training/categories', { method: 'POST', credentials: 'include', headers: await h(), body: JSON.stringify({ name }) });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const deleteTrainingCategory = async (id) => {
    try {
        const r = await fetch(`/training/categories/${id}`, { method: 'DELETE', credentials: 'include', headers: await h() });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const getAssignableUsers = async () => {
    try {
        const r = await fetch('/training/assignable-users', { headers: await h(), credentials: 'include' });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const getTrainingModules = async () => {
    try {
        const r = await fetch('/training/modules', { headers: await h(), credentials: 'include' });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const createTrainingModule = async (data) => {
    try {
        const r = await fetch('/training/modules', { method: 'POST', credentials: 'include', headers: await h(), body: JSON.stringify(data) });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const updateTrainingModule = async (id, data) => {
    try {
        const r = await fetch(`/training/modules/${id}`, { method: 'PUT', credentials: 'include', headers: await h(), body: JSON.stringify(data) });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const deleteTrainingModule = async (id) => {
    try {
        const r = await fetch(`/training/modules/${id}`, { method: 'DELETE', credentials: 'include', headers: await h() });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const bumpModuleVersion = async (id) => {
    try {
        const r = await fetch(`/training/modules/${id}/bump-version`, { method: 'POST', credentials: 'include', headers: await h() });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const uploadTrainingVideo = async (moduleId, file) => {
    try {
        const sessionToken = await getSessionUUID();
        const fd = new FormData();
        fd.append('file', file);
        // No Content-Type header — browser sets multipart boundary automatically
        const r = await fetch(`/training/modules/${moduleId}/video`, {
            method: 'POST', credentials: 'include',
            headers: { 'Authorization': `Bearer ${sessionToken}` },
            body: fd,
        });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const uploadTrainingDocument = async (moduleId, file) => {
    try {
        const sessionToken = await getSessionUUID();
        const fd = new FormData();
        fd.append('file', file);
        const r = await fetch(`/training/modules/${moduleId}/document`, {
            method: 'POST', credentials: 'include',
            headers: { 'Authorization': `Bearer ${sessionToken}` },
            body: fd,
        });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const getModuleQuestions = async (moduleId) => {
    try {
        const r = await fetch(`/training/modules/${moduleId}/questions`, { headers: await h(), credentials: 'include' });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const createQuestion = async (moduleId, data) => {
    try {
        const r = await fetch(`/training/modules/${moduleId}/questions`, { method: 'POST', credentials: 'include', headers: await h(), body: JSON.stringify(data) });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const updateQuestion = async (questionId, data) => {
    try {
        const r = await fetch(`/training/questions/${questionId}`, { method: 'PUT', credentials: 'include', headers: await h(), body: JSON.stringify(data) });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const deleteQuestion = async (questionId) => {
    try {
        const r = await fetch(`/training/questions/${questionId}`, { method: 'DELETE', credentials: 'include', headers: await h() });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const getTrainingRoles = async () => {
    try {
        const r = await fetch('/training/roles', { headers: await h(), credentials: 'include' });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const createTrainingRole = async (name) => {
    try {
        const r = await fetch('/training/roles', { method: 'POST', credentials: 'include', headers: await h(), body: JSON.stringify({ name }) });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const deleteTrainingRole = async (roleId) => {
    try {
        const r = await fetch(`/training/roles/${roleId}`, { method: 'DELETE', credentials: 'include', headers: await h() });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const setRoleRequirements = async (roleId, moduleIds) => {
    try {
        const r = await fetch(`/training/roles/${roleId}/requirements`, { method: 'PUT', credentials: 'include', headers: await h(), body: JSON.stringify({ module_ids: moduleIds }) });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const getUserTrainingRoles = async (userId) => {
    try {
        const r = await fetch(`/training/users/${userId}/training-roles`, { headers: await h(), credentials: 'include' });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const setUserTrainingRoles = async (userId, roleIds) => {
    try {
        const r = await fetch(`/training/users/${userId}/training-roles`, { method: 'PUT', credentials: 'include', headers: await h(), body: JSON.stringify({ role_ids: roleIds }) });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const getTrainingCompliance = async () => {
    try {
        const r = await fetch('/training/compliance', { headers: await h(), credentials: 'include' });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const getUserTrainingHistory = async (userId) => {
    try {
        const r = await fetch(`/training/users/${userId}/history`, { headers: await h(), credentials: 'include' });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};
